import React from 'react';

const Button = ({
  children,
  onClick,
  title = '',
  type = 'button',
  isLoading = false,
  loadingSpinner = true,
  loadingText = '',
  disabled = false,
  className = '',
}) => {
  const sizeStyles = 'h12 text-lg sm:h-10 sm:text-base md:h-8 md:text-sm';
  const baseStyles = 'flex items-center justify-center px-4 py-2 rounded-full font-semibold transition-colors duration-200 touch-manipulation';
  const disabledStyles = 'disabled:bg-gray-more disabled:cursor-not-allowed disabled:text-gray-mid';

  return (
    <button
      type={type}
      title={title}
      onClick={onClick}
      className={`${baseStyles} ${sizeStyles} ${className} ${disabled ? disabledStyles : ''}`}
      disabled={disabled || isLoading}
    >
      {
        isLoading ? (
          <div className="flex items-center gap-2">
            {loadingSpinner && (<i className={`fas fa-gear fa-spin text-white`} />)}
            {loadingText && (<span>{loadingText}</span>)}
          </div>
        ) : (
          children
        )}
    </button>
  );
};

export default Button;
